// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"524":"545a7f2f","580":"7820ba54"}[chunkId] + ".chunk.css";
};